// extracted by mini-css-extract-plugin
export var chip = "_ff-0";
export var filterDropdown = "_ff-5";
export var filterItem = "_ff-6";
export var icon = "_ff-1";
export var removeButton = "_ff-3";
export var removeIcon = "_ff-4";
export var separator = "_ff-2";